import { Ruleset } from "../game/Ruleset.js";


export function getOverallMeanMoveDelta(type: Ruleset): number {
    if (type === Ruleset.FINKEL) {
        return 0.41;
    } else if (type === Ruleset.BLITZ) {
        return 0.278;
    } else if (type === Ruleset.MASTERS || type === Ruleset.OLD_MASTERS) {
        return 0.232;
    } else {
        throw new Error(`Unsupported game type ${type.getName()}`);
    }
}


/**
 * Unrounded. Display sites floor it, so a shown 90% always means the
 * accuracy the server checks for achievements is at least 90.
 */
export function calculateAccuracy(
    type: Ruleset,
    meanMoveDelta: number,
): number {
    return 100 / ((meanMoveDelta / (2 * getOverallMeanMoveDelta(type))) + 1);
}


export function getRatingTargetAccuracy(accuracy: number): number {
    return 5000 * Math.pow(accuracy / 100.0, 4);
}
